import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApplicationPackage} from 'src/app/enums/application-package.enum';
import {Service} from 'src/app/enums/service.enum';
import {CustomHttpUrlEncodingCodec} from 'src/app/main/encoder';
import {CatchupRequestInfo} from 'src/app/model/cms-vod-core/catchup-models/catchup-request-info.model';
import {CatchupRequest, CatchupRequestScheduleGroup, PageOfCatchupRequest} from 'src/app/model/cms-vod-core/catchup-models/catchup-request-model';
import {environment} from 'src/environments/environment';
import {QueryParams} from '../../../model/query-models/query-models';

@Injectable({
  providedIn: 'root',
})
export class CatchupRequestService {
  readonly catchupRequestApiUrl = environment.endPoint + ApplicationPackage.CMS_VOD + Service.CATCHUP_REQUEST;

  constructor(private http: HttpClient) {}
  //Catchup Request List
  getAllCatchupRequest(requestParams: QueryParams): Observable<any> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

    // if (requestParams.releaseDate) {
    //   queryParams = queryParams.set('releaseDate', <any>requestParams.releaseDate);
    // }
    if (requestParams.channelName) {
      queryParams = queryParams.set('channelName', <any>requestParams.channelName);
    }
    if (requestParams.days) {
      queryParams = queryParams.set('days', <any>requestParams.days);
    }
    if (requestParams.programTitle) {
      queryParams = queryParams.set('programTitle', <any>requestParams.programTitle);
    }
    if (requestParams.sortParam) {
      queryParams = queryParams.set('sortParam', <any>requestParams.sortParam);
    }
    if (requestParams.catchupRequestStatus) {
      queryParams = queryParams.set('status', <any>requestParams.catchupRequestStatus);
    }
    if (requestParams.pageable) {
      if (requestParams.page > 0) {
        queryParams = queryParams.set('page', <any>requestParams.page);
      }
      if (requestParams.itemCount) {
        queryParams = queryParams.set('itemCount', <any>requestParams.itemCount);
      }
    } else {
      queryParams = queryParams.set('pageable', <any>false);
    }

    return this.http.get<any>(this.catchupRequestApiUrl, {params: queryParams});
  }

  createCatchupRequest(catchupRequest: CatchupRequest): Observable<CatchupRequest> {
    return this.http.post<CatchupRequest>(this.catchupRequestApiUrl, catchupRequest);
  }

  getCatchupRequestById(catchupRequestId: number): Observable<CatchupRequest> {
    return this.http.get<CatchupRequest>(this.catchupRequestApiUrl + `/${catchupRequestId}`);
  }

  getCatchupRequestsBySeriesId(seriesId: string): Observable<CatchupRequest[]> {
    return this.http.get<CatchupRequest[]>(this.catchupRequestApiUrl + `/byseries/${seriesId}`);
  }

  getCatchupRequestScheduleGroup(groupKey: string): Observable<CatchupRequestScheduleGroup> {
    if (!groupKey || !groupKey.trim()) {
      throw new Error('Catchup Request group key can not be blank');
    }
    return this.http.get<CatchupRequestScheduleGroup>(
      this.catchupRequestApiUrl + `/schedules/${encodeURIComponent(groupKey.trim())}`
    );
  }

  syncCatchupRequestSchedules(group: CatchupRequestScheduleGroup): Observable<CatchupRequestScheduleGroup> {
    return this.http.post<CatchupRequestScheduleGroup>(`${this.catchupRequestApiUrl}/sync`, group);
  }

  generatedCatchupInfo(seriesId: string): Observable<CatchupRequestInfo[]> {
    return this.http.get<CatchupRequestInfo[]>(this.catchupRequestApiUrl + `/${seriesId}/generatedCatchupInfo`);
  }

  updateCatchupRequest(catchupRequestContent: CatchupRequest): Observable<CatchupRequest> {
    return this.http.put<CatchupRequest>(this.catchupRequestApiUrl, catchupRequestContent);
  }

  getNotGeneratedCatchupsByCatchupRequest(releaseDate?: string): Observable<CatchupRequest[]> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (releaseDate) {
      queryParams = queryParams.set('releaseDate', <any>releaseDate);
    }
    return this.http.get<CatchupRequest[]>(this.catchupRequestApiUrl + '/notgeneratedcatchupsbycatchuprequest', {params: queryParams});
  }

  deleteCatchupRequest(seriesId: string): Observable<string> {
    return this.http.delete<string>(
      this.catchupRequestApiUrl + `/schedules/${encodeURIComponent(seriesId)}`,
      {responseType: 'text' as 'json'}
    );
  }

  deleteCatchupRequestsBySeriesId(seriesId: string): Observable<string> {
    return this.http.delete<string>(this.catchupRequestApiUrl + `/${seriesId}/series`, {responseType: 'text' as 'json'});
  }

  bulkUpdateCatchupRequest(oldRequests: CatchupRequest[], newRequests: CatchupRequest[]): Observable<void> {
    return this.http.post<void>(`${this.catchupRequestApiUrl}/bulk-update`, {
      oldRequests: oldRequests,
      newRequests: newRequests
    });
  }
}
